import { ViewFactory } from 'wdc-cube-react'
import ResultadoAnaliseScope from '../resultado_analise.scopes'
import ResultadoAnaliseView from './resultado_analise.view'

export function registerViews(rv = ViewFactory.register) {
    rv(ResultadoAnaliseScope, ResultadoAnaliseView)
}
